import Decimal from "decimal.js";
import { investorTransfereesUpsertBody } from "gen/schemas/investor-transfer/investor-transfer";
import i18n from "i18n/config";
import { decimalOrZero, decimalZero } from "shared/utils/DecimalUtils";

interface Context {
  commitmentAmount: Decimal;
}

export const investorTransfereeUpsertSchema = ({ commitmentAmount }: Context) =>
  investorTransfereesUpsertBody.refine(
    (value) => {
      const transferAmount = value.investor_transferee_entity_list.reduce(
        (acc, curr) => acc.plus(decimalOrZero(curr.transfer_amount)),
        decimalZero(),
      );
      return transferAmount.isZero() || transferAmount.lte(commitmentAmount);
    },
    {
      message: i18n.t(
        "investorTransfer:setup.transferees.errors.transferAmountGreaterThanCommitment",
      ),
      path: ["commitment_amount"],
    },
  );
